import { useState } from "react";
import { Plus } from "lucide-react";
import { Shimmer } from "../Shimmer/Shimmer";
import { CategoryTable } from "../CategoryTable/CategoryTable";
import { CategoryModal } from "../CategoryModal/CategoryModal";
import { useCategoryList } from "../../hooks/useCategoryList";
import "../RequestsSection/RequestsSection.scss";

export const CategorySection = () => {
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const { data, loading, error, refetch } = useCategoryList();

  return (
    <section className="requests-section requests-section--embedded" aria-label="Категории">
      <div className="requests-section-header">
        <h1 className="requests-section-title">Категории</h1>
        <button
          type="button"
          className="requests-section-create-btn"
          onClick={() => setCreateOpen(true)}
        >
          <Plus size={20} />
          <span>Создать категорию</span>
        </button>
      </div>

      {loading ? (
        <Shimmer rows={5} />
      ) : error ? (
        <div className="requests-section-error">
          <p className="requests-section-error__text">{error}</p>
          <button type="button" className="requests-section-error__retry" onClick={refetch}>
            Повторить
          </button>
        </div>
      ) : (
        <CategoryTable data={data} onRowClick={setSelectedId} />
      )}

      {createOpen && (
        <CategoryModal onClose={() => setCreateOpen(false)} onSaved={refetch} />
      )}

      {selectedId && (
        <CategoryModal
          categoryId={selectedId}
          onClose={() => setSelectedId(null)}
          onSaved={refetch}
        />
      )}
    </section>
  );
};
